import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { InvoiceMascot, MascotExpression } from './invoice-tour/invoice-mascot.component';
import '../scss/unsaved-changes-modal.scss';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onStay: () => void;
  onLeave: () => void;
  onSaveAndLeave?: () => void;
  isSaving?: boolean;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({
  isOpen,
  onStay,
  onLeave,
  onSaveAndLeave,
  isSaving = false,
}) => {
  const { t } = useTranslation();

  // Mascot mood: tense by default (unsaved changes!), relaxed/happy when
  // hovering "Save as draft", sad when hovering "Cancel".
  const [mood, setMood] = useState<MascotExpression>('confused');

  if (!isOpen) return null;

  return (
    <div className="unsaved-changes-overlay" onClick={onStay}>
      <div className="unsaved-changes-modal" onClick={(e) => e.stopPropagation()}>
        <button className="unsaved-changes-close" onClick={onStay}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M15 5L5 15M5 5L15 15" stroke="#717680" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="unsaved-changes-icon">
          <span className="unsaved-changes-mascot" aria-hidden="true">
            <span className="unsaved-changes-mascot-halo" />
            <InvoiceMascot expression={mood} />
          </span>
        </div>

        <h3 className="unsaved-changes-title">
          {t('UNSAVED_CHANGES_TITLE')}
        </h3>

        <p className="unsaved-changes-desc">
          {t('UNSAVED_CHANGES_DESC')}
        </p>

        <div className="unsaved-changes-footer">
          <button
            className="unsaved-btn unsaved-btn--outline"
            onClick={onLeave}
            onMouseEnter={() => setMood('sad')}
            onMouseLeave={() => setMood('confused')}
          >
            {t('STAY_ON_PAGE')}
          </button>
          <button
            className="unsaved-btn unsaved-btn--primary"
            onClick={onSaveAndLeave ?? onLeave}
            disabled={isSaving}
            onMouseEnter={() => setMood('happy')}
            onMouseLeave={() => setMood('confused')}
          >
            {isSaving && <span className="unsaved-btn-spinner" />}
            {t('SAVE_AS_DRAFT_AND_SWITCH')}
          </button>
        </div>
      </div>
    </div>
  );
};
